var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mb-1" },
    [
      _c(
        "h2",
        { staticClass: "text-sm uppercase text-center font-bold mb-2" },
        [_vm._v(_vm._s(_vm.title))]
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }